import React from 'react';
import jwt_decode from 'jwt-decode';
import "devextreme/data/odata/store";
import { createStore } from "devextreme-aspnet-data-nojquery";
import plusimg from "../../images/common/plus.png"
import exportimg from "../../images/common/xlsx.png"
import editimg from "../../images/common/pencil.png"
import onimg from "../../images/admin/on-button.png"
import offimg from "../../images/admin/off-button.png"
import history from "../history";
import {Form,Row,Modal,Button as ButtonBootstrap} from "react-bootstrap";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from 'react-toastify';    
import 'react-toastify/dist/ReactToastify.css'; 
import { exportToExcel } from '../../utils/exportMethods'; 
import '../../css/Buttons.css';
import {config} from '../../constants';
import ConfirmDialog from './pages/customComponents/ConfirmDialog';
import {deleteKey} from '../../utils/exportMethods';
import CircleSign from '../ui/CircleSign';
import ConfirmationModal from '../ui/ConfirmationModal';
import Maximize from '../ui/Maximize';
import Minimize from '../ui/Minimize';
import CustomDataGrid from './pages/customComponents/CustomDataGrid';
import apiClient from '../../utils/apiClient';
import { handleErrorResponse } from '../../utils/apiClient';

const url = config.url.URL; 
const exchangeRateLoadUrl = `${url}/ExchangeRateMicroservice`;
const sourceCurrenciesLoadUrl = `${exchangeRateLoadUrl}/sourceCurrencies`;
const targetCurrenciesLoadUrl = `${exchangeRateLoadUrl}/targetCurrencies`;
const corporateRatesLoadUrl = `${exchangeRateLoadUrl}/corporateRates`;

const dataSource = createStore({
  key: "exchangeRateId",
  loadUrl: `${url}/ExchangeRateMicroservice`,
  insertUrl: `${url}/InsertOrder`,
  updateUrl: `${url}/UpdateOrder`,
  deleteUrl: `${url}/ExchangeRateMicroservice`,
  onBeforeSend: (method, ajaxOptions) => {
    ajaxOptions.headers = {
      'accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }
  },
  onAjaxError: (e) => {
    const { xhr, error } = e;
    handleErrorResponse(error || { message: 'Unknown error occurred.', response: xhr });
  }
});

const exportExchangeRatesToExcel = async (apiData) => {
  apiData.forEach((obj) => {
    deleteKey(obj, 'exchangeRateId');
    deleteKey(obj, 'corporateRateId');
    deleteKey(obj, 'sourceCurrencyId');
    deleteKey(obj, 'targetCurrencyId');
  });

  const headers = [
    { header: 'Year', key: 'year', autoFit: true, type: 'int' },
    { header: 'Source Currency', key: 'sourceCurrencyName', autoFit: true },
    { header: 'Target Currency', key: 'targetCurrencyName', autoFit: true },
    { header: 'Corporate Rate', key: 'corporateRateName', autoFit: true },
    { header: 'Rate', key: 'rate', autoFit: true, type: 'float' },
    { header: 'Status', key: 'isEnabled', autoFit: true }
  ];

  await exportToExcel(headers, apiData, 'exchange_rates_extract', 'Exchange Rates Extract');
};

const appName = "";//ArchicubedWeb; //Production

class ExchangeRates extends React.Component {
    constructor(props) {
        super(props);
        this.applyFilterTypes = [{
          key: 'auto',
          name: 'Immediately'
        }, {
          key: 'onClick',
          name: 'On Button Click'
        }];
        this.state = {
          showFilterRow: true,
          showHeaderFilter: false,
          currentFilter: this.applyFilterTypes[0].key,
          showColumnLines: false,
          showRowLines: true,
          showBorders: true,
          rowAlternationEnabled: true,
          showModal: false,
          showEditModal: false,
          fullscreen:false,
          showConfirtmationModal: false,
          years: [],
          currentYear: null,
          currentCorporateRate: null,
          currentSourceCurrency: null,
          currentTargetCurrency: null,
          corporateRateOptions  : [],
          sourceCurrencyOptions : [],
          targetCurrencyOptions : [],
          validation: true,
          yearVal:true,
          sourceVal:true,
          targetVal:true,
          coVal:true,
          rateVal:true,
          duplicatedValidation:true,
          exchanges:[],
          selectedRowName:"",
          oldCheckValue: false,
        };

        this.dataGrid = null;
        this.onShowFilterRowChanged = this.onShowFilterRowChanged.bind(this);
        this.onShowHeaderFilterChanged = this.onShowHeaderFilterChanged.bind(this);
        this.onCurrentFilterChanged = this.onCurrentFilterChanged.bind(this);
        this.fetchCorporateRateOptions = this.fetchCorporateRateOptions.bind(this);
        this.fetchSourceCurrencyOptions = this.fetchSourceCurrencyOptions.bind(this);
        this.fetchTargetCurrencyOptions = this.fetchTargetCurrencyOptions.bind(this)

        this.selectedYear             = React.createRef();
        this.selectedSourceCurrency   = React.createRef();
        this.selectedTargetCurrency   = React.createRef();
        this.selectedCorporateRate    = React.createRef();
        this.selectedRate             = React.createRef();
        this.exchangeRateIsEnabled    = React.createRef();
        this.confDiag = React.createRef();
    }

  componentDidMount(){
    const decoded = jwt_decode(localStorage.getItem('token'));
    this.setState({
      can_export_to_excel: decoded.can_export_to_excel === "true"
    })
    const { state } = this.props.location;
    if (typeof(state) !== 'undefined' && state != null) {
    if(state.showNewPopup){
      this.setState({showModal:true});
    }
  }
    this.fetchYears();
    this.fetchCorporateRateOptions();
    this.fetchSourceCurrencyOptions();
    this.fetchTargetCurrencyOptions();
  }


  fetchYears(){
    const year = (new Date()).getFullYear() -4;
    this.state.years = Array.from(new Array(6),(val, index) => index + year);
  }

  fetchCorporateRateOptions() {
    apiClient.get(corporateRatesLoadUrl)
      .then(response => {
        const data = response.data;
        this.setState({
          corporateRateOptions: data
        });
      })
      .catch((error) => {
        if (error === 'Unauthorized') {
          return;
        }
      });
  }

  fetchSourceCurrencyOptions() {
    apiClient.get(sourceCurrenciesLoadUrl)
      .then(response => {
        const data = response.data;
        this.setState({ sourceCurrencyOptions: data });
      })
      .catch((error) => {
        if (error === 'Unauthorized') {
          return;
        }
      });
  }

  fetchTargetCurrencyOptions() {
    apiClient.get(targetCurrenciesLoadUrl)
      .then(response => {
        const data = response.data;
        this.setState({
          targetCurrencyOptions: data
        })
      })
      .catch((error) => {
        if (error === 'Unauthorized') {
          return;
        }
        console.error(error);
      });
  }

  fullscreenHandler=()=>{
    this.setState(prevState =>({fullscreen: !prevState.fullscreen}));
  }

  selectedChanged(e) {
    this.setState({
      selectedRowIndex: e.component.getRowIndexByKey(e.selectedRowKeys[0])
    });
  }

  // to refresh our datagrid table and close all modals
   useRefresh = () => {
    this.dataGrid.useRefresh();
    this.setState({
       showModal: false,
       showEditModal: false,
       showConfirmationModal: false,
     });
  }

  handleClose = () =>{
    this.setState({ showConfirmationModal: true });
  }

  closeConfirmationModal = ()=>{
    this.setState({ showConfirmationModal: false });
  }

  doubleCloseModals = () => {
    const { state } = this.props.location;
    if (typeof state !== "undefined" && state != null) {
      if (state.showNewPopup) {
        history.push({ pathname: "/admin", state: { showNewPopup: false } });
      }
    }
    this.setState({
      showModal: false,
      showEditModal: false,
      showConfirmationModal: false,
    });
  };
  
  handleEditClose = () =>{
      this.setState({ showConfirmationModal: true });
  }

  openModal = () => {   
     this.setState({showModal:true, duplicatedValidation: true ,
      validation:true, yearVal:true, sourceVal:true, targetVal:true, coVal:true, rateVal:true});
  }

  showDisabledEnabledToast = (value) => {
    if(!this.confDiag.current.state.inEditMode) {
      if(!value) {
        toast.success('Exchange Rate has been enabled');
      }
      else {
        toast.success('Exchange Rate has been disabled');
      }
    }
    else {
      if(value) {
        toast.success('Exchange Rate has been enabled');
      }
      else {
        toast.success('Exchange Rate has been disabled');
      }
    }
  }

  onCreateExchangeRate = () => {
    this.setState({ duplicatedValidation: true })
    let corporateRate = this.selectedCorporateRate.current.value;
    let sourceCurrency = this.selectedSourceCurrency.current.value;
    let targetCurrency = this.selectedTargetCurrency.current.value;
    let rate = this.selectedRate.current.value;
    let year = this.selectedYear.current.value;

    if (year == "") {
      this.setState({ yearVal: false })
    } else {
      year = Number(year)
      this.setState({ yearVal: true })
    }
    if (sourceCurrency == "") {
      this.setState({ sourceVal: false })
    } else {
      this.setState({ sourceVal: true })
    }
    if (targetCurrency == "") {
      this.setState({ targetVal: false })
    } else {
      this.setState({ targetVal: true })
    }
    if (corporateRate == "") {
      this.setState({ coVal: false })
    } else {
      this.setState({ coVal: true })
    }
    if (!this.isRateValid(rate)) {
      this.setState({ rateVal: false })
    } else {
      rate = Number(rate)
      this.setState({ rateVal: true })
    }

    if (year != "" && sourceCurrency != "" && targetCurrency != "" && corporateRate != "" && this.isRateValid(rate)) {

      let exchangeRate = {
        corporateRateId: corporateRate,
        sourceCurrencyId: sourceCurrency,
        targetCurrencyId: targetCurrency,
        rate: rate,
        year: year,
        isEnabled: true
      }

      apiClient.post(exchangeRateLoadUrl, exchangeRate)
      .then(response => {
        const data = response.data;
        if (data && data.statusCode == 400) {
          this.setState({ duplicatedValidation: false })
          return;
        }
        else {
          toast.success("Exchange Rate has been created");
          this.doubleCloseModals();
          const { state } = this.props.location;
          if (typeof (state) !== 'undefined' && state != null) {
            if (state.showNewPopup) {
              history.push({ pathname: "/admin", state: { 'showNewPopup': false } });
            }
          } else {
            this.useRefresh();
          }
        }
      });
    } else {
      this.setState({ validation: false })
      return;
    }
  }
    
  openEditModal = (e) => {    
    let selectedRowIndex = e.row.key;
    apiClient.get(exchangeRateLoadUrl.concat('/').concat(selectedRowIndex))
      .then(response => {
        const data = response.data;
        this.setState({
          showEditModal: true,
          duplicatedValidation: true,
          validation: true,
          yearVal: true,
          sourceVal: true,
          targetVal: true,
          coVal: true,
          rateVal: true,
          selectedRowIndex: selectedRowIndex,
          currentYear: data.year,
          currentCorporateRate: data.corporateRateId,
          currentSourceCurrency: data.sourceCurrencyId,
          currentTargetCurrency: data.targetCurrencyId
        });   
        this.selectedRate.current.value = data.rate;
        this.exchangeRateIsEnabled.current.checked = data.isEnabled;
        this.setState({oldCheckValue: e.row.data.isEnabled});
      })      
   }

  onEditExchangeRate = () => {
    let corporateRateId = this.state.currentCorporateRate;
    let sourceCurrencyId = this.state.currentSourceCurrency;
    let targetCurrencyId = this.state.currentTargetCurrency;
    let year = this.state.currentYear;
    let rate = this.selectedRate.current.value;
    let isEnabled = this.state.oldCheckValue;

    if (!this.isRateValid(rate)) {
      this.setState({ rateVal: false })
      return;
    } else {
      rate = Number(rate)
      this.setState({ rateVal: true })
    }

    let exchangeRate = {
      exchangeRateId: this.state.selectedRowIndex,
      corporateRateId: corporateRateId,
      sourceCurrencyId: sourceCurrencyId,
      targetCurrencyId: targetCurrencyId,
      year: year,
      rate: rate,
      isEnabled: isEnabled
    }

    apiClient.put(exchangeRateLoadUrl, exchangeRate)
    .then(response => {
      const data = response.data;
      if (data.statusCode == 400) {
        this.setState({ duplicatedValidation: false })
        return;
      }
      else {
        if (data && data.statusCode == 200) {
          if (this.state.oldCheckValue != this.exchangeRateIsEnabled.current.checked) {
            this.confDiag.current.state.status = this.exchangeRateIsEnabled.current.checked
            this.confDiag.current.state.inEditMode = true;
            this.confDiag.current.state.key = this.state.selectedRowIndex;
            this.confDiag.current.handleOpenConfirmDialog();
          } else {
            toast.success('Exchange Rate has been updated');
            this.doubleCloseModals();
            const { state } = this.props.location;
            if (typeof (state) !== 'undefined' && state != null) {
              if (state.showNewPopup) {
                history.push({ pathname: "/admin", state: { 'showNewPopup': false } });
              }
            } else {
              this.useRefresh();
            }
          }
        } else toast.error("Error " + response.statusCode);
      }
    });
  }

  onExportToExcel = () => {
    apiClient.get(`${url}/ExchangeRateMicroservice`)
      .then(response => {
        const data = response.data;
        if (data) {
          exportExchangeRatesToExcel(data);
          toast.success('Exchange Rates Excel export file has been generated');
        }
      });
  }

  isRateValid = (rate) => {
    if(+rate >0){
      return true;
    }else{
      return false
    }
  }

  Checkisenabled = (e) =>{
    return e.row.data.isEnabled ;
  }

  Checkisdisabled = (e) =>{
  return !e.row.data.isEnabled ;
  }

  onDelete = (e) => {
    this.confDiag.current.state.key = e.row.data.exchangeRateId;
    this.confDiag.current.state.status = e.row.data.isEnabled;
    this.confDiag.current.state.inEditMode = false;
    this.confDiag.current.handleOpenConfirmDialog();
  }

  render() {
    let optionYears = this.state.years.map((year) =>
        <option value={year}>{year}</option>
    );

    let corporateRateOptions = this.state.corporateRateOptions.map((corporateRate) =>
        <option value={corporateRate.corporateRateId}>{corporateRate.name}</option>
    );

    let sourceCurrencyOptions = this.state.sourceCurrencyOptions.map((sourceCurrency) =>
      sourceCurrency.currencyCode != 'LCL' ?
        <option value={sourceCurrency.currencyId}>{sourceCurrency.currencyCode} - {sourceCurrency.name}</option> : ""
    );

    let targetCurrencyOptions = this.state.targetCurrencyOptions.map((targetCurrency) =>
      targetCurrency.currencyCode != 'LCL' ?
        <option value={targetCurrency.currencyId}>{targetCurrency.currencyCode} - {targetCurrency.name}</option> : ""
    );

    const columns = [
      { dataField: "isEnabled", caption: "Status", width: "110" },
      { dataField: "year", caption: "Year", width: "20%", alignment: "left" },
      { dataField: "sourceCurrencyName", caption: "Source Currency", width: "20%"},
      { dataField: "targetCurrencyName", caption: "Target Currency", width: "20%"},
      { dataField: "corporateRateName", caption: "Corporate Rate", width: "20%"},
      { dataField: "rate", caption: "Rate", width: "20%",  alignment: "left"},
      // Add other columns specific to Profiles component
    ];

    const buttonColumn = [
      {text: "Edit", icon: editimg, className: "img-grid", name: "edit", onClick: this.openEditModal},
      {text: "btn_enabled", icon: onimg, hint: "Disable", visible: this.Checkisenabled, name: "delete", onClick: this.onDelete},
      {text: "btn_disabled", icon: offimg, hint: "Enable", visible: this.Checkisdisabled, name: "delete", onClick: this.onDelete},
      // Additional buttons for Profiles component
    ];

    return (
      <div className="div-body-section-details">
        <div className="div-body-section-details-header">
        <div className="div-section-title">
          <span>
          Exchange Rates Management
          </span>
        </div>
        
        <div className="div-section-actions push">
          <button  className={this.state.can_export_to_excel ? "btn-section-header" : "btn-section-header hidden" }  onClick={this.onExportToExcel}>
              <img className="img-section-header" src={exportimg} />
              <label>Export To Excel</label></button>
          <button  className="btn-section-header" onClick={this.openModal} >
              <img className="img-section-header" src={plusimg} />
              <label>New Exchange Rate</label>
          </button>
        </div>
        </div>
        <div className="div-body-section-details-header-subtitle">
          <span>
          1 Source Currency = X Target Currency
          </span>
        </div>
        <div  className="div-padding-20">
           <CustomDataGrid
              dataSource={dataSource}
              keyExpr="exchangeRateId"
              ref={(ref) => (this.dataGrid = ref)}
              rowAlternationEnabled={this.state.rowAlternationEnabled}
              showFilterRow={this.state.showFilterRow}
              currentFilter={this.state.currentFilter}
              showHeaderFilter={this.state.showHeaderFilter}
              columns={columns}
              buttonColumn={buttonColumn}
            />
      </div>
      <ToastContainer position="bottom-right"/>  
 
      <Modal show={this.state.showModal} onHide={this.handleClose} size="xs" centered fullscreen={this.state.fullscreen} className="exchange-new">
          <Modal.Header closeButton>
            <Modal.Title>New Exchange Rate</Modal.Title>
            <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
          </Modal.Header>
          <Modal.Body>
          {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Exchange Rate already exists, your updates cannot be saved. Please go back to Exchange Rates Management list to edit the corresponding form.</p></Row>  } 
        {!this.state.validation && this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Exchange Rate form is not allowed</p></Row>  } 
            <Form.Label className={`${this.state.yearVal ? "label-rate" : "validation-title"}`}>Year  <CircleSign/></Form.Label>
            <Form.Control  
              placeholder="Year" 
              ref={this.selectedYear} 
              required 
              as="select" 
              className={`select-placeholder ${!this.state.yearVal && "validation-control"}`}>
            <option value="" hidden>Year</option>
                  {optionYears}
            </Form.Control>
            {!this.state.yearVal && <p className="p-required">Required</p>}

            <Form.Label className={`${this.state.sourceVal ? "label-rate" : "validation-title"}`}>Source Currency  <CircleSign/></Form.Label>
            <Form.Control 
              placeholder='Source Currency' 
              required 
              as="select" 
              type="select"
              ref={this.selectedSourceCurrency}
              className={`select-placeholder ${!this.state.sourceVal && "validation-control"}`}
            >
              <option value="" hidden>Source Currency</option>
              {sourceCurrencyOptions}
            </Form.Control>
            {!this.state.sourceVal && <p className="p-required">Required</p>}

            <Form.Label className={`${this.state.targetVal ? "label-rate" : "validation-title"}`}>Target Currency  <CircleSign/></Form.Label>
            <Form.Control 
              placeholder='Target Currency' 
              required 
              as="select" 
              type="select"
              ref={this.selectedTargetCurrency}
              className={`select-placeholder ${!this.state.targetVal && "validation-control"}`}
            >
              <option value="" hidden>Target Currency</option>
              {targetCurrencyOptions}
            </Form.Control>
            {!this.state.targetVal && <p className="p-required">Required</p>}

            <Form.Label className={`${this.state.coVal ? "label-rate" : "validation-title"}`}>Corporate Rate  <CircleSign/></Form.Label>
            <Form.Control 
              placeholder='Corporate Rate' 
              required as="select" 
              type="select"
              ref={this.selectedCorporateRate}
              className={`select-placeholder ${!this.state.coVal && "validation-control"}`}
            >
              <option value="" hidden>Corporate Rate</option>
              {corporateRateOptions}
            </Form.Control>
            {!this.state.coVal && <p className="p-required">Required</p>}
            
            <Form.Label className={`${this.state.rateVal ? "label-rate" : "validation-title"}`}>Rate  <CircleSign/></Form.Label>
            <Form.Control type="number" min="0" ref={this.selectedRate} placeholder="Rate" className={`${!this.state.rateVal && "validation-control"}`}/>
            {!this.state.rateVal && <p className="p-required">Value must be positive</p>}

          </Modal.Body>

          <Modal.Footer>
          <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onCreateExchangeRate}>
            Create Exchange Rate
            </ButtonBootstrap>
            <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleClose}>
              Cancel
            </ButtonBootstrap>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.showEditModal} onHide={this.handleEditClose} size="xs" centered fullscreen={this.state.fullscreen}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Exchange Rate</Modal.Title>
            <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
          </Modal.Header>

          <Modal.Body> 
          {!this.state.rateVal && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Exchange Rate form is not allowed</p></Row>  }            
            <Form.Label className={`${this.state.rateVal ? "label-rate" : "validation-title"}`}>Rate  <CircleSign/></Form.Label>
            <Form.Control type="number" min="0" ref={this.selectedRate} placeholder="Rate" className={`${!this.state.rateVal && "validation-control"}`}/>
            {!this.state.rateVal && <p className="p-required">Value must be positive</p>}

            <br/>
            <Form.Check type="checkbox" label="Is Enabled" ref={this.exchangeRateIsEnabled}/>
          </Modal.Body>

          <Modal.Footer>
          <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onEditExchangeRate}>
              Update Exchange Rate
            </ButtonBootstrap>
            <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleEditClose}>
              Cancel
            </ButtonBootstrap>
          </Modal.Footer>
        </Modal>

        <ConfirmationModal show={this.state.showConfirmationModal} hide={this.closeConfirmationModal} doubleCloseModals={this.doubleCloseModals} msg="Your updates won't be saved. Are you sure you want to leave this page
          ?"/>

        <ConfirmDialog ref={this.confDiag} editfunction={this.showDisabledEnabledToast} refreshfunction={this.useRefresh} microserviceName="ExchangeRateMicroservice"></ConfirmDialog>
      </div>
    );
  }
  onShowFilterRowChanged(e) {
    this.setState({
      showFilterRow: e.value
    });
    this.clearFilter();
  }

  onShowHeaderFilterChanged(e) {
    this.setState({
      showHeaderFilter: e.value
    });
    this.clearFilter();
  }

  onCurrentFilterChanged(e) {
    this.setState({
      currentFilter: e.value
    });
  }

  clearFilter() {
    this.dataGrid.clearFilter();
  }
}

export default ExchangeRates;
